// Shared home for extractQuotedProjectName — originally private to
// studio-composer.tsx, extracted here (Plan B1 Task 4) so both
// studio-composer.tsx (app-creation-prompt routing) and
// shell/ide-v2/components/chat-messages.tsx (the template-proposal card's
// onAccept handler) can use the exact same quoted-name extraction without
// chat-messages.tsx importing studio-composer.tsx's entire (assistant-ui +
// mcp-bus + sipass/woori reference generation) dependency graph just for
// this one pure function. Behavior is byte-identical to the prior private
// implementation.
export function extractQuotedProjectName(text: string): string | null {
  const match =
    text.match(/project name(?: is|:)?\s*["“]([^"”]+)["”]/i) ??
    text.match(/프로젝트\s*이름(?:은|:)?\s*["“]([^"”]+)["”]/);
  return match?.[1]?.trim() || null;
}
